export const menuRoles = {
    itemMenu: {
        diariaAdicional: {
            roles: [
                'DIARIA-ADICIONAL_DIARIA-ADICIONAL_DELETAR',
                'DIARIA-ADICIONAL_DIARIA-ADICIONAL_SALVAR',
                'DIARIA-ADICIONAL_DIARIA-ADICIONAL_VISUALIZAR',
                'DIARIA-ADICIONAL_TERCEIROS_VISUALIZAR',
                'DIARIA-ADICIONAL_TERCEIROS_SALVAR',
                'DIARIA-ADICIONAL_TERCEIROS_DELETAR',
                'DIARIA-ADICIONAL_VALORES-DE-DIARIA_DELETAR',
                'DIARIA-ADICIONAL_VALORES-DE-DIARIA_SALVAR',
                'DIARIA-ADICIONAL_VALORES-DE-DIARIA_VISUALIZAR'
            ],
            diariaAdicional: {
                visualizar: ['DIARIA-ADICIONAL_DIARIA-ADICIONAL_VISUALIZAR'],
                salvar: ['DIARIA-ADICIONAL_DIARIA-ADICIONAL_SALVAR'],
                deletar: ['DIARIA-ADICIONAL_DIARIA-ADICIONAL_DELETAR']
            },
            terceiros: {
                visualizar: ['DIARIA-ADICIONAL_TERCEIROS_VISUALIZAR'],
                salvar: ['DIARIA-ADICIONAL_TERCEIROS_SALVAR'],
                deletar: ['DIARIA-ADICIONAL_TERCEIROS_DELETAR']
            },
            valoresDiaria: {
                visualizar: ['DIARIA-ADICIONAL_VALORES-DE-DIARIA_VISUALIZAR'],
                salvar: ['DIARIA-ADICIONAL_VALORES-DE-DIARIA_SALVAR'],
                deletar: ['DIARIA-ADICIONAL_VALORES-DE-DIARIA_DELETAR']
            }
        },
        menu: {
            roles: ['TESTE_SALVAR', 'TESTE_DELETAR', 'TESTE_VISUALIZAR'],
            teste: {
                visualizar: ['TESTE_VISUALIZAR'],
                salvar: ['TESTE_SALVAR'],
                deletar: ['TESTE_DELETAR']
            }
        }
    }
};
